import React, { ReactElement } from "react";
import { EmblaOptionsType } from "embla-carousel";

import useEmblaCarousel from "embla-carousel-react";
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "./MultiCarouselArrowButtons";
import { DotButton, useDotButton } from "./CarouselDotButton";

type MultiCarouselProps = {
  slides: ReactElement[];
  options?: EmblaOptionsType;
  containerClassName?: string;
  includeDots?: boolean;
};

const MultiCarousel = ({
  slides,
  options,
  containerClassName = "",
  includeDots = false,
}: MultiCarouselProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const loopingPadding = options?.loop ? "last:pl-4 last:large:pl-6" : "";

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  return (
    <section className="embla">
      <div className="embla__viewport overflow-x-hidden" ref={emblaRef}>
        <div
          className={`embla__container grid touch-pan-y touch-pinch-zoom grid-flow-col gap-4 large:gap-6 ${loopingPadding} ${containerClassName}`}
        >
          {slides.map((slide) => slide)}
        </div>
      </div>

      {(!nextBtnDisabled || !prevBtnDisabled) && (
        <div className="embla__controls">
          <div className="embla__buttons mt-4 flex justify-center gap-6 medium:mt-8">
            <PrevButton
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
            />

            {includeDots && (
              <div className="embla__dots mx-4 flex flex-wrap items-center gap-2">
                {scrollSnaps.map((_, index) => (
                  <DotButton
                    key={index}
                    onClick={() => onDotButtonClick(index)}
                    className={
                      index === selectedIndex
                        ? "bg-teal-700"
                        : "bg-zinc-500 opacity-30"
                    }
                  />
                ))}
              </div>
            )}

            <NextButton
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default MultiCarousel;
